import type { TimedAtom } from '@ctcells/api'
import { enumLabel, t } from '@ctcells/i18n'

import { Checkbox } from '../../atoms/Checkbox.tsx'
import { Field } from '../../atoms/Field.tsx'
import { Segmented } from '../../atoms/Segmented.tsx'

import { checkItems, type ResumeCheck } from './resumeRouteModel.ts'

import '../screens.css'

/*
 * 멈춘 작업을 잇는 대화의 **입력 칸 둘**(현장 확인 체크 · 시간 원자 방식). 갈래 · 판정 · 글자는 `resumeRouteModel.ts` 에 있다
 * (react-refresh — 컴포넌트 파일은 컴포넌트만 내보낸다).
 */

/**
 * 확인 재개 전 **현장 확인 체크 목록**. 끊김이 따로 요구하는 확인(`resume_checks`)이 있으면 그 칸마다 하나,
 * 없으면 `physical_checked` 의 뜻(장비 · 쥔 것 · 시료 자리) 한 칸이다. 🔴 전부 체크해야 보낼 수 있다(`allChecked`).
 */
export function CutAtomChecks({
  checks,
  checked,
  onChange,
}: {
  checks: readonly ResumeCheck[]
  checked: ReadonlySet<string>
  onChange: (next: ReadonlySet<string>) => void
}) {
  const items = checkItems(checks)
  const toggle = (key: string, on: boolean) => {
    const next = new Set(checked)
    if (on) next.add(key)
    else next.delete(key)
    onChange(next)
  }
  return (
    <Field label={t('halt.checks')}>
      <div className="resume-checks" role="group" aria-label={t('halt.checks')}>
        {items.map((item) => (
          <Checkbox
            checked={checked.has(item.key)}
            key={item.key}
            label={item.label}
            onChange={(on) => toggle(item.key, on)}
          />
        ))}
      </div>
    </Field>
  )
}

/** 끊긴 시간 원자 방식 고르기 — `choices` 가 비면(하나뿐 · 없음) 아무것도 안 그린다 */
export function TimedAtomPick({
  choices,
  value,
  onChange,
}: {
  choices: readonly TimedAtom[]
  value: TimedAtom
  onChange: (next: TimedAtom) => void
}) {
  if (choices.length < 2) return null
  return (
    <Field label={t('resume.timedAtom')}>
      <Segmented
        label={t('resume.timedAtom')}
        onChange={onChange}
        options={choices.map((choice) => ({
          value: choice,
          label: enumLabel('enum.timedAtom', choice),
        }))}
        value={value}
      />
    </Field>
  )
}
